export const ORDER_STATUS = {
  PENDING_PAYMENT: "pending_payment",
  PAID: "paid",
  PICKING: "picking",
  SHIPPED: "shipped",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
};

export const ORDER_STATUS_LABEL_PT = {
  [ORDER_STATUS.PENDING_PAYMENT]: "Aguardando pagamento",
  [ORDER_STATUS.PAID]: "Pago",
  [ORDER_STATUS.PICKING]: "Em separação",
  [ORDER_STATUS.SHIPPED]: "Enviado",
  [ORDER_STATUS.DELIVERED]: "Entregue",
  [ORDER_STATUS.CANCELLED]: "Cancelado",
};

export const ORDER_STATUS_COLOR = {
  [ORDER_STATUS.PENDING_PAYMENT]: "warning",
  [ORDER_STATUS.PAID]: "info",
  [ORDER_STATUS.PICKING]: "primary",
  [ORDER_STATUS.SHIPPED]: "secondary",
  [ORDER_STATUS.DELIVERED]: "success",
  [ORDER_STATUS.CANCELLED]: "error",
};

export function normalizeOrderStatus(raw) {
  if (!raw) return ORDER_STATUS.PENDING_PAYMENT;

  // Legacy (antigos)
  if (raw === "pending") return ORDER_STATUS.PENDING_PAYMENT;
  if (raw === "completed") return ORDER_STATUS.DELIVERED;

  // PT-BR (telas antigas)
  if (raw === "Aguardando pagamento") return ORDER_STATUS.PENDING_PAYMENT;
  if (raw === "Pago") return ORDER_STATUS.PAID;
  if (raw === "Em separação") return ORDER_STATUS.PICKING;
  if (raw === "Enviado") return ORDER_STATUS.SHIPPED;
  if (raw === "Entregue") return ORDER_STATUS.DELIVERED;
  if (raw === "Cancelado") return ORDER_STATUS.CANCELLED;

  // Novo padrão (já normalizado)
  if (Object.values(ORDER_STATUS).includes(raw)) return raw;

  return ORDER_STATUS.PENDING_PAYMENT;
}

export function getOrderStatusLabelPt(rawStatus) {
  const s = normalizeOrderStatus(rawStatus);
  return ORDER_STATUS_LABEL_PT[s] || ORDER_STATUS_LABEL_PT[ORDER_STATUS.PENDING_PAYMENT];
}

export function getOrderStatusColor(rawStatus) {
  const s = normalizeOrderStatus(rawStatus);
  return ORDER_STATUS_COLOR[s] || "warning";
}

export function isFinalOrderStatus(rawStatus) {
  const s = normalizeOrderStatus(rawStatus);
  return s === ORDER_STATUS.DELIVERED || s === ORDER_STATUS.CANCELLED;
}

export function buildOrderTimeline({ status, createdAt, events }) {
  const createdTs = typeof createdAt === "number" ? createdAt : null;
  const normalized = normalizeOrderStatus(status);

  const formatBR = (ts) => {
    if (!ts) return "-";
    const d = new Date(ts);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  };

  // Se houver eventos no Firebase, usar como fonte principal
  if (events && typeof events === "object") {
    const arr = Object.keys(events)
      .map((k) => ({ id: k, ...events[k] }))
      .filter((e) => e && e.at)
      .sort((a, b) => (a.at || 0) - (b.at || 0))
      .map((e) => {
        if (e.type === "created") return { label: "Pedido criado", at: formatBR(e.at), done: true };
        if (e.type === "tracking") return { label: "Rastreio atualizado", at: formatBR(e.at), done: true };
        if (e.type === "status") return { label: getOrderStatusLabelPt(e.to || e.status), at: formatBR(e.at), done: true };
        return { label: "Atualização", at: formatBR(e.at), done: true };
      });

    // Garantir que existe um "Pedido criado"
    const hasCreated = arr.some((x) => x.label === "Pedido criado");
    if (!hasCreated) arr.unshift({ label: "Pedido criado", at: formatBR(createdTs), done: true });

    return arr;
  }

  // Fallback: timeline derivada do status (sem eventos)
  const order = [
    ORDER_STATUS.PENDING_PAYMENT,
    ORDER_STATUS.PAID,
    ORDER_STATUS.PICKING,
    ORDER_STATUS.SHIPPED,
    ORDER_STATUS.DELIVERED,
  ];

  const currentIndex = order.indexOf(normalized);
  const base = [{ label: "Pedido criado", at: formatBR(createdTs), done: true }];

  order.forEach((s, idx) => {
    if (s === ORDER_STATUS.PENDING_PAYMENT) return;
    if (normalized === ORDER_STATUS.CANCELLED) return;
    base.push({
      label: ORDER_STATUS_LABEL_PT[s],
      at: "-",
      done: currentIndex >= idx,
    });
  });

  if (normalized === ORDER_STATUS.CANCELLED) {
    base.push({ label: ORDER_STATUS_LABEL_PT[ORDER_STATUS.CANCELLED], at: "-", done: true });
  }

  return base;
}

